export let dataProps = {
    id: 0,
    target_currency_id: null,
    rate: 0
}


// WEBPACK FOOTER //
// ./src/store/modules/currencyExchange/properties.js